export default "__VITE_ASSET__C54l7kMY__"